<template>
    <div>
        <!--  :class="toptype==1?'header-relative':'header-fixed'" -->
        <div class="header header-relative">
            <div class="flex justify-center align-center sheight">
                <div class="pointer" @click="tohome" style="width: 150px">
                    <el-image
                        style="width: 80px; height: 80px"
                        src="/static/assets/images/logo1.png"
                        fit="fill"
                    ></el-image>
                </div>
                <div class="swidth">
                    <el-input
                        placeholder="请输入内容"
                        v-model="keyword"
                        class="input-with-select"
                        @keyup.enter.native="tosearch"
                    >
                        <el-select
                            @change="tabselect"
                            v-model="selectid"
                            slot="prepend"
                            placeholder="信息服务"
                        >
                            <el-option
                                v-for="(item, index) in selectlist"
                                :key="index"
                                :label="item.title"
                                :value="item.value"
                            ></el-option>
                            <!-- <el-option label="技术服务" value="2"></el-option> -->
                        </el-select>
                        <el-button
                            @click="tosearch"
                            slot="append"
                            icon="el-icon-search"
                            style="background-color: #fff"
                        >
                            搜索
                        </el-button>
                    </el-input>
                </div>
                <div
                    v-if="!token"
                    @click="tologin"
                    class="text-center pointer"
                    style="width: 150px"
                >
                    登录/注册
                </div>
                <div
                    v-if="token && info"
                    class="flex justify-center align-center"
                    style="margin-left: 10px; width: 300px"
                >
                    <div class="headerbox_right_tu">
                        <img
                            style="
                                border-radius: 50%;
                                width: 100%;
                                height: 100%;
                            "
                            :src="info.avatar | addurl"
                        />
                    </div>
                    <el-popconfirm @confirm="signout" title="确定退出？">
                        <el-button
                            class="text-cut"
                            style="
                                border: none;
                                color: #5778f5;
                                background: rgba(255, 255, 255, 0);
                                width: 150px;
                            "
                            slot="reference"
                        >
                            欢迎您，{{
                                info.username ? info.username : info.nickname
                            }}
                        </el-button>
                    </el-popconfirm>
                    <el-button plain @click="topersonal" style="color: #5778f5"
                        >个人中心</el-button
                    >
                </div>
            </div>
            <div
                v-if="toptype == 1"
                class="response navall"
                style="
                    background: rgba(255, 255, 255, 0);
                    position: absolute;
                    top: 105px;
                    z-index: 99;
                "
            >
                <div
                    class="
                        flex
                        justify-between
                        align-center
                        marginauto
                        text-white
                        navcon
                    "
                >
                    <template v-for="(item, index) in toplist">
                        <div
                            class="toponenew text-center pointer"
                            :class="{ activenew: toptype == item.type }"
                            @click="changenav(item.type, item.path)"
                        >
                            {{ item.title }}
                        </div>
                    </template>
                </div>
            </div>
            <div v-else class="response navall">
                <div
                    class="
                        flex
                        justify-between
                        align-center
                        marginauto
                        text-white
                        navcon
                    "
                >
                    <template v-for="(item, index) in toplist">
                        <div
                            class="topone text-center pointer"
                            :class="{ active: toptype == item.type }"
                            @click="changenav(item.type, item.path)"
                        >
                            {{ item.title }}
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- <div  v-if="toptype!=1" style="height:175px;" ></div> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "topnav",
    computed: {
        ...mapGetters(["userinfo", "token"]),
    },
    props: {
        isIndex: {
            type: Boolean,
            default: false,
        },
        toptype: {
            type: [Number, String],
            default: "",
        },
        keywords: {
            type: String,
            default: "",
        },
        types: {
            type: [Number, String],
            default: "1",
        },
        isSearch: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            keyword: "",
            selectid: "1",
            toplist: [
                {
                    type: 1,
                    title: "首页",
                    path: "/",
                },
                {
                    type: 4,
                    title: "创业服务",
                    path: "/risk",
                },
                {
                    type: 6,
                    title: "政策服务",
                    path: "/finance",
                },
                {
                    type: 5,
                    title: "活动资讯",
                    path: "/train",
                },
                {
                    type: 7,
                    title: "场地服务",
                    path: "/tenancy",
                },
                {
                    type: 8,
                    title: "在孵企业",
                    path: "/company",
                },
            ],
            info: "",
            selectlist: [
                // {
                //     title: "全部",
                //     value: "0",
                //     path: "/searchpage",
                // },
                {
                    title: "创业服务",
                    value: "1",
                    path: "/risklist",
                },
                {
                    title: "政策服务",
                    value: "2",
                    path: "/finance",
                },
                {
                    title: "活动资讯",
                    value: "3",
                    path: "/train",
                },
                {
                    title: "场地服务",
                    value: "4",
                    path: "/tenancy",
                },
                {
                    title: "在孵企业",
                    value: "5",
                    path: "/company_list",
                },
            ],
            path: "",
            type: "",
        };
    },
    methods: {
        tohome() {
            this.$router.push({ path: "/" });
        },
        tosearch() {
            // if(!this.keyword){
            //   this.$message.error('请输入搜索内容');
            //   return false;
            // }
            var data = {
                type: this.selectid,
                keyword: this.keyword,
            };
            // if(this.isSearch == 1){
            //   this.$emit('tosearch',JSON.stringify(data))
            // }else{
            //   var path = '/search';
            //   this.$router.push({path:path,query:{type:this.selectid,keyword: this.keyword}})
            // }
            // console.log('this.selectlist',this.selectlist)
            this.selectlist.forEach((item) => {
                if (this.selectid == item.value) {
                    // console.log(item.path)
                    this.path = item.path;
                }
            });
            console.log("this.isSearch", this.isSearch);
            console.log("this.path", this.path);
            if (this.isSearch == this.path) {
                console.log("搜索：");
                this.$emit("tosearch", JSON.stringify(data));
            } else {
                // this.path
                localStorage.setItem("type", this.selectid);
                this.$router.push({
                    // path: "/searchpage",

                    path: this.path,
                    query: { type: this.selectid, keyword: this.keyword },
                });
            }
        },
        tabselect(res) {
            // console.log('res',res)
        },
        changenav(type, path) {
            // this.$emit('navtype',type)
            this.$router.push({ path: path });
        },
        tologin() {
            this.$router.push({ path: "/login" });
        },
        topersonal() {
            if (this.type == 1) {
                this.$router.push({ path: "/system" });
            } else if (this.type == 2) {
				
				if (this.info.shop) {
				    if (this.info.shop.status == 0) {
				        this.$message("申请已提交，正在审核中");
				        return false;
				    } else if (this.info.shop.status == 2) {
				        this.$alert(
				            this.info.shop.remark,
				            "您的申请被拒绝,请重新申请",
				            {
				                confirmButtonText: "确定",
				                callback: (action) => {
				                    this.$router.push({
				                        path: "/companyinfo",
				                        query: { id: this.info.shop.id },
				                    });
				                },
				            }
				        );
				        return false;
				    } else if (this.info.shop.status == 1) {
				        // this.$message("您已成功入驻！");
						this.$router.push({path: '/service'})
				        return false;
				    }
				}
				
				
                // if (!this.info.shop) {
                //     this.$message.error("请先入驻企业");
                //     setTimeout(() => {
                //         this.$router.push({ path: "/companyinfo" });
                //     }, 800);
                //     return false;
                // } else {
                //     if (this.info.shop.status == 0) {
                //         this.$message.info("正在审核中");
                //     } else if (this.info.shop.status == 1) {
                //         this.$router.push({ path: "/personal" });
                //     } else if (this.info.shop.status == 2) {
                //         this.$message.error(
                //             "您的申请被拒绝：" + this.info.shop.remark
                //         );
                //         this.$alert(this.info.shop.remark, "您的申请被拒绝：", {
                //             confirmButtonText: "重新申请",
                //             callback: (action) => {
                //                 this.$router.push({ path: "/companyinfo" });
                //             },
                //         });
                //     }
                // }
            }
			 this.$router.push({path: '/companyinfo'})
        },
        signout() {
            // this.$https.post(
            //   {
            //     type: "formData",
            //     api: api,
            //   },
            //   {
            //     sign: sign,
            //   },
            //   (response) => {
            //     // console.log("response", response);
            //   },
            //   (error) => {
            //     console.log(error);
            //   }
            // );
            if (this.type == 2) {
                var data = {
                    sign: this.info.sign,
                };
                this.$api.user.logout(data).then((response) => {});
            }

            // localStorage.clear();
            localStorage.removeItem("type");
            localStorage.removeItem("userinfo");
            localStorage.removeItem("name");
            localStorage.removeItem("avatar");
            localStorage.removeItem("token");

            this.$store.dispatch("user/logout");
            this.$router.go(0);
            // this.$router.push({path: '/'})
            // logout
        },
        getuserinfo() {
            var type = localStorage.getItem("type");
            if (type == 2) {
                var types = 1;
            } else if (type == 1) {
                var types = 2;
            }
            var data = {
                type: types,
                user_id: this.token,
            };
            this.$api.user.userinfo(data).then((res) => {
                var data = res.data;
                this.info = data;
                var sdata = JSON.stringify(data);
                // this.$store.commit('SET_USERINFO',sdata)
                localStorage.setItem("userinfo", sdata);
            });
        },
    },
    created() {
        // console.log('userinfo123',this.userinfo)
        this.info = JSON.parse(this.userinfo);
        this.type = localStorage.getItem("type");
        console.log("this.type:", this.type);
        this.keyword = this.keywords ? this.keywords : "";
        this.selectid = this.types ? this.types : this.type;

        if (localStorage.getItem("token")) {
            this.getuserinfo();
        }
    },
};
</script>

<style>
.el-select .el-input {
    width: 110px;
}
.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>
<style scoped>
.header {
    background-color: #fff;
}
.header-fixed {
    position: fixed;
    z-index: 9;
    width: 100%;
}
.header-relative {
    position: relative;
}

.headerbox_right_tu {
    width: 30px;
    height: 30px;
    background-color: #f7af34;
    border-radius: 50%;
}
.active {
    background-color: #0044c6;
}
.topone {
    width: 150px;
    height: 70px;
    line-height: 70px;
}
.toponenew {
    width: 150px;
    height: 38px;
    line-height: 38px;
}
.activenew {
    border-radius: 19px;
    background-color: #fff;
    color: #0060ed;
}
.sheight {
    height: 105px;
}
.swidth {
    width: 910px;
}
.navall {
    height: 70px;
    background-color: #1759d8;
}
.navcon {
    width: 1200px;
    height: 70px;
}
</style>


// WEBPACK FOOTER //
// topnav.vue?0598a8a6